<template>
    <v-dialog class="rounded-0" v-model="isActive" width="500" persistent transition="dialog-bottom-transition">
        <v-card>
            <v-card-text class="d-flex flex-row justify-center ma-0">
                <v-icon color="success" size="120" class="mt-3">mdi-check-circle-outline</v-icon>
            </v-card-text>
            <!--  <v-progress-linear v-if="loading" indeterminate height="5" color="orange"></v-progress-linear> -->
            <v-card-text class="d-flex flex-column align-center font-weight-bold text-h6 primary--text">
                Solicitud enviada
            </v-card-text>
            <v-card-text class="d-flex font-weight-regular text-body-1 black--text ">
                <div v-html="formatText(text)"></div>
            </v-card-text>
            <v-card-text>
                <div class="d-flex font-weight-regular justify-center text-body-1 black--text">
                    Si no recibís el mail, revisá tu correo no deseado.
                </div>
            </v-card-text>
            <v-card-text class="d-flex flex-column align-center">
                <v-btn @click="gotToTramites" width="250px" elevation="0" color="primary" class="pa-5 mb-1">
                    VER MIS TRÁMITES
                </v-btn>
                <v-btn @click="gotToView" width="250px" elevation="0" color="primary" class="pa-5 mb-1">
                    contacto
                </v-btn>
                <v-btn outlined @click="continuar(false)" width="250px" elevation="0" color="primary" class="pa-5">
                    cerrar
                </v-btn>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
export default {
    props: ['titulo'],
    data() {
        return {
            isActive: false,
            callback: null,

            text: "Tú solicitud de Subsidio fue enviada y queda sujeta a revisión por parte de las áreas correspondientes. Recibiras un mail con el estado del trámite."
        }
    },
    mounted() {
    },
    methods: {
        ...mapActions('auth', ['cerrarSesion', 'refreshToken']),

        formatText(text) {
            const boldTexts = [
                'Subsidio',
                'sujeta a revisión',
            ];

            // Use a regular expression to replace each occurrence of the bold texts with their bolded versions
            boldTexts.forEach(boldText => {
                const regex = new RegExp(boldText, 'g');
                text = text.replace(regex, `<b>${boldText}</b>`);
            });

            // Cambia de línea después de cada punto seguido de un espacio
            text = text.replace(/\. /g, '.<br>');
            return text;
        },


        abrirDialog() {
            this.isActive = true;
            return new Promise(resolve => {
                this.callback = resolve;
            })
        },
        continuar(result) {
            if (this.callback) {
                this.callback(result);
                this.callback = null; // Reset the callback to avoid memory leaks
            }
            this.isActive = false
        },

        gotToTramites() {
            this.$router.push('/Tramites').catch(() => { })
        },
        gotToView() {
            this.$router.push('/mediosDeContacto').catch(() => { })
        },
    },
    computed: {
        ...mapGetters('auth', ['user'])
    },
}

</script>